import { motion } from 'framer-motion';

interface NutrientRowProps {
  label: string;
  value?: string | number;
  percentage?: number;
  boldLabel?: boolean;
  indent?: boolean;
  noBorder?: boolean;
}

const NutrientRow = ({
  label,
  value,
  percentage,
  boldLabel = false,
  indent = false,
  noBorder = false,
}: NutrientRowProps) => {
  return (
    <motion.div
      whileHover={{ backgroundColor: 'rgba(0,0,0,0.05)', x: 4 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      className={`flex justify-between items-end py-[3px] ${
        noBorder ? '' : 'border-t border-black'
      }`}
      style={{ paddingLeft: indent ? '1.25rem' : '0' }}
    >
      <div>
        <span
          className={`text-[13px] leading-tight ${boldLabel ? 'font-black' : 'font-normal'}`}
        >
          {label}
        </span>
        {value !== undefined && (
          <span className="text-[13px] leading-tight ml-1 font-normal">
            {value}
          </span>
        )}
      </div>

      {percentage !== undefined && !isNaN(percentage) && (
        <span className="text-[13px] leading-tight font-black">
          {percentage}%
        </span>
      )}
    </motion.div>
  );
};

export default NutrientRow;
